const playlistNames = [
  'Rock and Roll Call',
  'Bass-ically Amazing',
  'Treble Trouble',
  'Chord-ially Invited',
  'Note-able Collection',
  'Melody Maker',
  'Rhythm and Bruise',
  'Pitch Perfect',
  'Sound Check Please',
  'Beat the Heat',
  'Tune In Tokyo',
  'Key Change Champions',
  'Harmony Haven',
  'Soul Food for Thought',
  'Groove is in the Heart',
  'Bass Drop Society',
  'Treble Makers',
  'Chord-ial Reception',
  'Note-worthy Jams',
  'Melody Makers',
  'Rhythm Nation',
  'Pitch Black',
  'Sound Wave Riders',
  'Beat Generation',
  'Tune Squad',
  'Key to My Heart',
  'Harmony Central',
  'Soul Searching',
  'Groove Machine',
  'Bass Boosted',
  'Rock the Boat',
  'Bass-ically Yours',
  'Treble in Paradise',
  'Chord on Blue',
  'Note to Self',
  'Melody Lane',
  'Rhythm & Clues',
  'Pitch Slapped',
  'Sound Advice',
  'Beat It',
  'Tune Town',
  'Key Lime Vibes',
  'Harmony Highway',
  'Soul Survivor',
  'Groove Train',
  'Bass Instinct',
  'Treble Threat',
  'Chord of the Rings',
  'Note Worthy',
  'Melody & Me',
  'Rhythm & Rhyme',
  'Pitch Please',
  'Sound of Silence',
  'Beat Street',
  'Tune Time',
  'Key of Life',
  'Harmony Hub',
  'Soul Patrol',
  'Groove Theory',
  'Bass Kicker',
  'Treble Trouble',
  'Chord Play',
  'Note to Note',
  'Melody Mix',
  'Rhythm & Blues',
  'Pitch Perfectly',
  'Sound Off',
  'Beat Box',
  'Tune Twist',
  'Key Players',
  'Harmony House',
  'Soul Beats',
  'Groove Garden',
  'Bassline Bliss',
  'Treble Makers',
  'Chord-ial Invitation',
  'Note by Note',
  'Melody Moments',
  'Rhythm & Grooves',
  'Pitch This',
  'Beat the Clock',
  'Tune Up',
  'Key to the City',
  'Harmony Heights',
  'Soulful Groove',
];

export function getRandomPlaylistName(): string {
  const randomIndex = Math.floor(Math.random() * playlistNames.length);
  return playlistNames[randomIndex];
}
